import { Route, Routes, } from "react-router-dom";
import './App.css';
import './assets/css/style.css';
import FormBillingExternalServices from './app/pages/FormExternalServices/FormBillingExternalServices';
import ComparePlame from "./app/pages/ComparePlame/ComparePlame";
import OfficeFurnitureCatalog from "./app/pages/OfficeFurniture/OfficeFurnitureCatalog";
import OfficeFurnitureSale2 from "./app/pages/OfficeFurniture/OfficeFurnitureSale2";
import OfficeFurnitureSale3 from "./app/pages/OfficeFurniture/OfficeFurnitureSale3";
import AdvertisementsViewer from "./app/pages/AdvertisementsViewer/AdvertisementsViewer";
import EquipmentRegister from "./app/pages/EquipmentRegister/EquipmentRegister";
import EquipmentView from "./app/pages/EquipmentRegister/EquipmentView";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ReportApp from "./app/pages/Report/ReportApp/ReportApp";


function App() {
  return (
    <div className="App" style={{ minHeight: "100vh" }}>
      <div style={{ padding: '10px' }}>
        <BodyWeb />
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} />
    </div>
  );
}

function BodyWeb() {
  const pathInit = null;
  return (
    <div style={{ height: "100%", }}>
      <Routes>
        <Route path={`${(pathInit || '/')}`} element={<FormBillingExternalServices />}></Route>
        <Route path={`${(pathInit || '')}/compare-plame`} element={<ComparePlame />}></Route>
        <Route path={`${(pathInit || '')}/anuncios/:fileName`} element={<AdvertisementsViewer />} />
        <Route path={`${(pathInit || '')}/equipment-register`} element={<EquipmentRegister />}></Route>
        <Route path={`${(pathInit || '')}/equipment-view`} element={<EquipmentView />}></Route>
     {  /* <Route path={`${(pathInit || '')}/office-furniture-catalog`} element={<OfficeFurnitureCatalog />}></Route>
        <Route path={`${(pathInit || '')}/office-furniture-sale`} element={<OfficeFurnitureSale2 />}></Route> */}
        <Route path={`${(pathInit || '')}/office-garage-sale`} element={<OfficeFurnitureSale3 />}></Route>
        <Route path={`${(pathInit || '')}/report-app`} element={<ReportApp />}></Route>
        </Routes>
    </div>
  )
}

export default App;